//扩展vue
// import wxFn from './wxFn'
import native from './native'
import weui from 'weui.js'
import util from './util'
import postHttp from './postHttp'
import '../../../static/css/weui.css'
import globel from './globel'
// wxFn.wxConfig();



const extendFn = {
  install (Vue){
    // Vue.prototype.$wxFn = wxFn;
    Vue.prototype.$native = native;
    Vue.prototype.$weui = weui;
    Vue.prototype.$util = util;
    Vue.prototype.$postHttp = postHttp;
    Vue.prototype.$GLOBEL=globel;
  }
};
export default extendFn;




// WEBPACK FOOTER //
// ./src/plugin/extendFn/index.js